module.exports = __webpack_public_path__ + "img/bg.49bcd304.png";